import * as React from 'react';
import card from '../../images/karta-mm.png'
import Account from "./Account";
import {getCurrentUser} from "../../utilities/Utilities";
import Services from "../../utilities/Services";
import {AplikacjeMobilne} from "../sharedComponents/AplikacjeMobilne";
import {notify} from "../../utilities/notify";
import {MapaOsm} from "./MapaOsm";

interface Props {
}

interface State {
    user: any,
    oddzialy: any,
    loading: boolean,
    selectedOddzial: any
}

export class TwojSklep extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            user: [],
            oddzialy: [],
            loading: false,
            selectedOddzial: []
        }
    }

    componentDidMount() {
        this.pobierzKlient();


    }

    pobierzOddzialy = () => {
        Services.getOddzialy()
            .then((response) => {
                if (response.status === 200) {

                    console.log("get Oddzialy ok");

                    this.setState({oddzialy: response.data.sort(
                            (a: any, b: any) => {
                                return a.adres.localeCompare(
                                    b.adres,
                                );
                            },
                        ).map((oddzial: any) => {return oddzial}), loading: false});

                    this.ustawMape(this.state.user.numag);

                }
            }).catch((error) => {
            this.setState({loading: false});
            console.log('get Oddzialy error');
        })
    }

    pobierzKlient = (pokazLadowanie: boolean = true) => {
        if (pokazLadowanie) this.setState({loading: true});

        Services.getKlient(getCurrentUser().email)
            .then((response) => {
                if (response.status === 200) {
                    console.log("get Klient ok");
                    this.setState({user: response.data});
                    this.pobierzOddzialy();
                }
            }).catch((error) => {
            this.setState({loading: false});
            console.log('get Klient error');
        })
    }

    onChangeSklep = (e: any) => {
        const poprzedniSklep = this.state.user.numag;
        // Lista od razu pokazuje wybrany sklep; przy błędzie zapisu wraca do poprzedniego.
        this.setState({user: {...this.state.user, numag: Number(e.target.value)}});

        Services.ustawSklepKlienta(e.target.value)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {

                    //this.setState({onRegister: true, registerLoading: false})
                    console.log("Zmiana Sklepu ok");
                    notify.info("Pomyślnie zmieniono twój sklep", 'Zmieniono sklep');

                    this.pobierzKlient(false);

                }
            }).catch((error) => {
            this.setState({user: {...this.state.user, numag: poprzedniSklep}});
            notify.error(error.response.data.message, 'Błąd zmiany sklepu');
            console.log('Zmiana Sklepu error');
        })

    }

    ustawMape = (numag: any) => {
        let odz = this.state.oddzialy;
        let oddzial: any = odz.find((o: any) => o.numag === numag)

        if(oddzial){
            this.setState({selectedOddzial: oddzial});
        }

    }

    render() {
        let {oddzialy, user, loading, selectedOddzial} = this.state;

        return <section id={'card'}>
            <h1 className={'h3'}>Twój sklep stacjonarny</h1>

            {/*<div className={'col-sm-3'}>Twój sklep:</div>*/}
            {(loading) ?
                <p className={'h5'} role={'status'}>Ładowanie...</p>
                :
                <div>
                    <div className={'col-sm-8'}>
                        <label htmlFor={'wybor-sklepu'} className={'sr-only'}>Wybierz swój sklep stacjonarny</label>
                        <select id={'wybor-sklepu'} className={'form-control'}
                                onChange={this.onChangeSklep}
                            //@ts-ignore
                                value={((user.numag) !== 0) ? user.numag : null}
                        >
                            <option value="" disabled selected>Wybierz twój sklep...</option>
                            {
                                oddzialy.map((oddzial: any) => (
                                    <option value={oddzial.numag}>{oddzial.miasto}, {oddzial.adres}</option>
                                ))
                            }
                        </select>
                    </div>

                    <div className={'col-sm-8 mt-3'}>
                        <b>{selectedOddzial.miasto}</b>
                        <p>{selectedOddzial.adres}</p>

                        <div dangerouslySetInnerHTML={{__html: selectedOddzial.opis}} className={'opisHtml'}/>

                        <b>Telefon:</b>
                        <p>{selectedOddzial.telefon}</p>
                    </div>

                    <MapaOsm lat={selectedOddzial.gpsLat} lng={selectedOddzial.gpsLng}
                             nazwa={`${selectedOddzial.miasto}, ${selectedOddzial.adres}`}/>

                </div>
            }
        </section>
    }

}

export default TwojSklep;

